// extracted by mini-css-extract-plugin
export default {"container":"DisclaimerBox_container__SKEMi","closed":"DisclaimerBox_closed__A2g5x","children":"DisclaimerBox_children__0CRq5"};